import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Uang Muka Penjualan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Uang Muka Penjualan',
        href: '/adm/fin/penjualan/invoice',
        active: true,
      },
    ],
    form_title: 'Form Uang Muka Penjualan',
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_um_jual',
    sortDesc: true,
    fields: [
      {
        key: 'code_um',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'date_um',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'currency_name',
        label: 'Currency',
      },
      {
        key: 'nominal',
        label: 'Nominal',
      },
      {
        key: 'terpakai',
        label: 'Terpakai',
      },
      {
        key: 'sisa',
        label: 'Sisa',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_um',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'date_um',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'currency_name',
        label: 'Currency',
      },
      {
        key: 'total_sisa',
        label: 'Nominal',
      },
    ],
    journal: {},
    form: {
      id_principle: '',
      principle_code: '',
      principle_name: '',
      id_currency: '',
      acc_um: '',
      acc_um_code: '',
      acc_um_name: '',
      nominal: 0,
      date_um: '',
      memo: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeUMJual(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListUM({ commit, state }, payload = null) {
    commit('changeUMJual', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      for_invoice: data.for_invoice ? data.for_invoice : 0,
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/uang-muka-penjualan`, params);
      commit('changeUMJual', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_um_jual.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/uang-muka-penjualan`, params);
      commit('changeUMJual', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getJournalUMJual({ commit }, payload = null) {
    commit('changeUMJual', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/uang-muka-penjualan/${payload.id}/journal`
    );
    commit('changeUMJual', {
      loading: false,
    });

    if (!result.error) {
      commit('changeUMJual', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailUangMuka({ commit, state }, payload = null) {
    commit('changeUMJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/uang-muka-penjualan/${payload.id}`);
    commit('changeUMJual', {
      loading: false,
    });

    if (!result.error) {
      commit('changeUMJual', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          date_um: result.data.object.date_um
            ? moment(result.data.object.date_um).format('DD/MM/YYYY')
            : moment().format('DD/MM/YYYY'),
        },
      });
    }

    return !result.error ? true : false;
  },

  async createUangMuka({ commit, state, dispatch }) {
    commit('changeUMJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/uang-muka-penjualan', data.form);

    commit('changeUMJual', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateUangMuka({ commit, state, dispatch }, payload = null) {
    commit('changeUMJual', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `fin/uang-muka-penjualan/${payload.id}`,
      data.form
    );

    commit('changeUMJual', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteUM({ commit, dispatch }, payload = null) {
    commit('changeUMJual', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `fin/uang-muka-penjualan/${payload.id}`
    );
    commit('changeUMJual', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
